import { render } from "./NiifNoControlante.vue?vue&type=template&id=402f4966&scoped=true"
import script from "./NiifNoControlante.vue?vue&type=script&lang=js"
export * from "./NiifNoControlante.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./NiifNoControlante.vue?vue&type=style&index=1&id=402f4966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402f4966"]])

export default __exports__